module.exports = __webpack_public_path__ + "img/_privacy.30bf753f.svg";